





































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { IInvoice, TFormValidator, ICustomer } from "@/interfaces";
import { USERNAME_RULES } from "@/validators";
import { SubmitInvoice, FindEmail } from "@/api";
@Component({})
export default class SearchEmailComponent extends Vue {
  public loading = false;
  public search: string = "";
  public selectedEmails: string[] = [];
  public items: string[] = [];

  mounted() {}

  private to__: number = 0;

  @Prop()
  public value!: string[];

  /* VUE WATCH */
	@Watch("value", {immediate:true})
	onValue(newVal: any, oldVal:any){
		if (newVal && newVal.length>0)
			this.selectedEmails = newVal;
	}

	@Watch("selectedEmails")
  onSelEmails(newVal: any, oldVal: any) {
		var nv = 0;
		if (newVal)nv = newVal.length;
		var ov = 0;
		if (oldVal)ov = oldVal.length;

		if (nv>ov){
			/*
			 MEANS WE ARE ADDING ITEMS. 
			 BLUR THE COMPONENT.
			 */
			this.$nextTick(()=>{
					(this.$refs['cbox'] as any).blur();
			})
		}else{
			/* IF WE ARE NOT ADDING, DON'T BLUR.
				 IT FEELS BETTER IF WE DON'T BLUR DURING DELETE OPERATIONS.
				 OTHERWISE IT BLURS ON EVERY DELETE, AND WE HAVE TO RE-FOCUS TO KEEP DELETING.
				 THAT DOESN'T FEEL RIGHT.
			 */
		}
	}

  @Watch("search")
  onValueChanged(newVal: any, oldVal: any) {
    clearTimeout(this.to__);
    this.to__ = setTimeout(() => {
      this.loading = true;
      FindEmail(this.search)
        .then(resp => {
          this.items = resp.Results;
        })
        .catch(errr => {})
        .then(() => {
          this.loading = false;
        });
    }, 200);
  }

  searchChanged() {
    /* RESET THE SEARCH KEYWORD SO IT DOES NOT REMAIN IN THE CONTROL
     */
    this.search = "";
    this.$emit("input", this.selectedEmails);
  }
}
